/* eslint-disable max-statements */
/* eslint-disable max-len */
import moment from 'moment';
import {noTimeZoneFullISODate} from '../../common/constants/datesFormat';

export const generateFormData = ({data, isUserTde, dealerId}) => {
  const visible = isUserTde || data?.dealerReservation === dealerId;
  return {
    'id': data?.id || '',
    'documentType': visible ? (data?.documentType || '') : '',
    'legalRepresentativeType': visible ? (data?.legalRepresentativeType || '') : '',
    'document': visible ? (data?.document) : '',
    'documentFile': visible ? (data?.documentFile || '') : '',
    'names': visible ? (data?.names || '') : '',
    'lastNames': visible ? (data?.lastNames || '') : '',
    'clientType': visible ? (data?.clientType || '') : '',
    'dealerReservation': isUserTde ? (data?.dealerReservation || '') : (data?.floatingState === 'D' ? dealerId : (data?.dealerReservation || '')),
    'adviserCode': data?.adviserCode || '',
    'certificate': visible ? (data?.certificate || 'N') : '',
    'certificateFile': visible ? (data?.certificateFile || '') : '',
    'exonerationPerc': visible ? (data?.exonerationPerc || '') : '',
    'discapacityPerc': visible ? (data?.discapacityPerc || '') : '',
    'hasLegalRepresentative': visible ? (data?.hasLegalRepresentative || 'N') : '',
    'legalRepresentativeId': visible ? (data?.legalRepresentativeId || '') : '',
    'legalRepresentativeName': visible ? (data?.legalRepresentativeName || '') : '',
    'location': visible ? (data?.location || '') : '',
    'city': visible ? (data?.city || '') : '',
    'province': visible ? (data?.province || '') : '',
    'country': visible ? (data?.country || 'EC') : '',
    'phoneNumber': visible ? (data?.phoneNumber || '') : '',
    'email': visible ? (data?.email || '') : '',
    'floatingState': data?.floatingState || '',
    'floatingVisible': data?.floatingVisible || 'N',
    'reserveAdvance': (data?.floatingState === 'D' && !data?.reserveAdvance) ? 'SC' : (data?.reserveAdvance || ''),
    'solNacNumber': data?.solNacNumber || '',
    'informBillDate': data?.informBillDate || '',
    'observations': data?.observations || '',
    'line': data?.line || '',
    'orderNumber': data?.orderNumber || '',
    'description': data?.description || '',
    'katashiki': data?.katashiki || '',
    'sfx': data?.sfx || '',
    'externalColor': data?.externalColor || '',
    'externalColorId': data?.externalColorId || '',
    'internalColor': data?.internalColor || '',
    'internalColorId': data?.internalColorId || '',
    'arrivalDate': data?.arrivalDate || '',
    'chassis': data?.chassis || '',
    'motor': data?.motor || '',
    'yearModel': data?.yearModel || '',
    'fobValue': data?.fobValue || '',
    'locationText': data?.locationText || '',
    'depositDate': data?.depositDate || '',
    'businessType': data?.businessType || '',
    'contributorCode': data?.contributorCode || '',
    'solNacDate': data?.solNacDate || '',
    'reservationFloatingDate': data?.reservationFloatingDate || '',
    'estSaleDate': data?.estSaleDate || '',
    'estBillDate': data?.estBillDate || '',
    'status': data?.status || '',
    'daysInDeposit': data?.daysInDeposit?.split('/')[0] || '',
    'importerName': data?.importerName || '',
  };
};

export const generateDataByTable = (data, userEmail) => {
  return {
    'floating_client': {
      'document_type': data?.documentType,
      'legal_representative_type': data?.hasLegalRepresentative === 'S' ? data?.legalRepresentativeType : null,
      'has_legal_representative': data?.hasLegalRepresentative,
      'document': data?.document,
      'names': data?.documentType !== 'R' ? data?.names : null,
      'last_names': data?.lastNames,
      'certificate': data?.certificate || false,
      'legal_representative_id': data?.hasLegalRepresentative === 'S' ? data?.legalRepresentativeId : null,
      'legal_representative_name': data?.hasLegalRepresentative === 'S' ? data?.legalRepresentativeName : null,
      'location': data?.location,
      'city': data?.city,
      'province': data?.province,
      'country': 'EC',
      'phone_number': data?.phoneNumber,
      'email': data?.email,
      'contributor_code': data?.contributorCode,
      'dealer_ruc': data?.dealerReservation,
    },
    'special_client_fields': {
      'client_type': data?.clientType,
      'discapacity_perc': data?.discapacityPerc,
      'exoneration_perc': data?.exonerationPerc,
    },
    'detail': {
      'floating_visible': 'S',
      'final_client': data?.document,
      'dealer_reservation': data?.dealerReservation,
      'adviser': data?.adviserCode,
      'floating_state': data?.floatingState,
      'reserve_advance': data?.reserveAdvance,
      'sol_nac_number': data?.solNacNumber,
      'inform_bill_date': data?.informBillDate || null,
      'observation_floating_inventory': data?.observations,
      'business_type': data?.businessType,
      'discapacity_perc': data?.discapacityPerc,
      'exoneration_perc': data?.exonerationPerc,
      'client_type': data?.clientType,
      'est_sale_date': data?.estSaleDate || null,
      'est_bill_date': data?.estBillDate || null,
      'final_customer_name': data?.lastNames + ((data?.documentType !== 'R' && ` ${data?.names}`) || ''),
    },
    'additional_data': {
      'user_email': userEmail,
    },
  };
};

export const setBgColor = (row) => {
  if (row.original.daysOldDeposit > 90) {
    return 'red-color-floating';
  } else if (row.original.daysOldDeposit > 60) {
    return 'yellow-color-floating';
  }
  return 'green-color-floating';
};

export const generateDealerIndividual = (listDealers, user) => {
  const dataDealer = listDealers.find((dealer) => {
    return dealer?.identification === user;
  });
  return dataDealer ? [{
    'key': dataDealer?.identification,
    'value': dataDealer?.identification,
    'text': dataDealer?.name,
  }] : [];
};

export const generateTimeLine = (data) => {
  const timeLineData = [
    {
      'id': 'arrivalDate',
      'description': 'LLEGADA',
      'status': false,
      'dateType': data?.arrivalDate ? moment(data?.arrivalDate, noTimeZoneFullISODate) : null,
      'date': data?.arrivalDate,
    },
    {
      'id': 'reservationFloatingDate',
      'description': 'RESERVA',
      'status': false,
      'dateType': moment(data?.reservationFloatingDate ? moment(data?.reservationFloatingDate, noTimeZoneFullISODate) : null),
      'date': data?.reservationFloatingDate,
    },
    {
      'id': 'solNacDate',
      'description': 'SOLICITUD NACIONALIZACIÓN',
      'status': false,
      'dateType': data?.solNacDate ? moment(data?.solNacDate, noTimeZoneFullISODate) : null,
      'date': data?.solNacDate,
    },
    {
      'id': 'estSaleDate',
      'description': 'LIQUIDACIÓN ESTIMADA',
      'status': false,
      'dateType': data?.estSaleDate ? moment(data?.estSaleDate, noTimeZoneFullISODate) : null,
      'date': data?.estSaleDate ? moment(data?.estSaleDate, noTimeZoneFullISODate).format(noTimeZoneFullISODate) : null,
    },
    {
      'id': 'estBillDate',
      'description': 'FACTURACIÓN ESTIMADA',
      'status': false,
      'dateType': data?.estBillDate ? moment(data?.estBillDate, noTimeZoneFullISODate) : null,
      'date': data?.estBillDate ? moment(data?.estBillDate, noTimeZoneFullISODate).format(noTimeZoneFullISODate) : null,
    },
  ];
  return timeLineData;
};

export const fieldHasError = (value, validations = []) => {
  const validationsArray = [...validations];
  let errorValue = {'value': value, 'error': false};
  for (let i = 0; i < validationsArray.length; i++) {
    errorValue = validationsArray[i](errorValue.value);
    if (errorValue.error) {
      break;
    }
  }
  return errorValue?.error;
};
